import React from 'react';
import Modal from '@mui/material/Modal';
import { Box } from '@mui/material';
import LoaderComponent from '../LoaderComponent/LoaderComponent';
import WelcomeModalStyle, { styles } from './WelcomeModal.styles';
import APP_CONSTANT from './constant';

interface WelcomeModalProps {
    show: boolean;
    data: any[];
    isLoader: boolean;
    selectedIndex: number;
    handleClose: ((event: any) => void);
    navigateCarousel: ((event: any, index: number) => void);
}

const WelcomeModal = (props: WelcomeModalProps) => {
    const { TEXT } = APP_CONSTANT;

    return (
        <Modal open={props?.show} onClose={props?.handleClose} BackdropProps={{ style: styles?.BackdropProps }} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box sx={styles?.box}>
                <WelcomeModalStyle>
                    <div className="welcome-modal-close-icon">
                        <span className="close-icon" onClick={props?.handleClose}>×</span>
                    </div>
                    <div className="main-container">
                        {props?.isLoader ? <LoaderComponent style={{ width: 'auto' }} />
                            : <>{props?.data?.filter((_, pageIdx) => props?.selectedIndex === pageIdx)?.map((page, pageIdx) =>
                                <div key={pageIdx}>
                                    {page?.DesignPattern === 'Row' && <div className="inner-card-list">
                                        <div className="layout_header_container_title_content">{page?.PageTitle}</div>
                                        <div className="list_block">
                                            {page?.Rows?.map((row, rowIndex) => (
                                                <div className="list" key={rowIndex}>
                                                    <img src={row?.Image} alt="img" />
                                                    <div className='list_container'>
                                                        <div className="list-heading-list">{row?.Heading}</div>
                                                        <div className="list_content">{row?.Content}</div>
                                                    </div>
                                                </div>))}
                                        </div>
                                    </div>}
                                    {page?.DesignPattern === 'Column' && <div className="column_type_card">
                                        <div className="header">
                                            <p className="small_title">{page?.Category}</p>
                                            <p className="layout_header_container_title_content">{page?.PageTitle}</p>
                                        </div>
                                        <div className="blocks">
                                            <div className="right-block">
                                                <div className="heading">
                                                    <div className="list-heading-list">{page?.LeftColumn?.Heading}</div>
                                                    <p className="list_content">{page?.LeftColumn?.Content}</p>
                                                </div>
                                                <div className="image-block">
                                                    <img src={page?.LeftColumn?.Image} alt="img" />
                                                </div>
                                            </div>
                                            <div className="left-block">
                                                <div className="heading">
                                                    <div className="list-heading-list">{page?.RightColumn?.Heading}</div>
                                                    <p className="list_content">{page?.RightColumn?.Content}</p>
                                                </div>
                                                <div className="image-block">
                                                    <img src={page?.RightColumn?.Image} alt="img" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                </div>)}

                                <div className="carousel_block">
                                    {props?.selectedIndex !== 0
                                        ? <button className="prev_btn" onClick={(event) => props?.navigateCarousel(event, props?.selectedIndex - 1)}>
                                            <span>{TEXT.BACK}</span>
                                        </button> : <></>}
                                    <div className="carousel_dots">
                                        {props?.data?.map((_, pageIdx) => (
                                            <span key={pageIdx} className={`dots ${props?.selectedIndex === pageIdx ? 'active' : ''}`}
                                                onClick={(event) => props?.navigateCarousel(event, pageIdx)}>
                                            </span>))}
                                    </div>
                                    <button className="next_btn" onClick={(event) => props?.navigateCarousel(event, props?.selectedIndex + 1)}>
                                        <span>{TEXT.NEXT}</span>
                                    </button>
                                </div>
                                <div className="skip_for_now" onClick={props?.handleClose}>
                                    <a href="JavaScript:Void(0)">{TEXT.SKIP}</a>
                                </div>
                            </>}
                    </div>
                </WelcomeModalStyle>
            </Box>
        </Modal>
    );
};
export default WelcomeModal;
